const DOCUMENTOS_VENTAS = 'documentos_ventas';
const DOCUMENTOS_COMPRAS = 'documentos_compras';
const CONSECUTIVOS = 'consecutivos';
const CONSTANTES = 'constantes';
const ATRIBUTOS = 'atributos';
const CLASIFICACIONESTRIBUTARIAS_ITEMS_CONCEPTOS = 'clasificacionestributarias_items_conceptos';
const CLASIFICACIONESTRIBUTARIAS_TERCEROS_CONCEPTOS = 'clasificacionestributarias_terceros_conceptos';
const CONCEPTOS_TRIBUTARIOS = 'conceptos_tributarios';
const DOCUMENTOS_INVENTARIOS = 'documentos_inventarios';
const DOCUMENTOS_PROCESOS = 'documentos_procesos';
const DOCUMENTOS_WMS = 'documentos_wms';
const GRUPOS_PAGOS = 'grupos_pagos';
const PERIODICIDADES = 'periodicidades';
const PRODUCTOS = 'productos';
const TRAMITES = 'tramites';
const TERCEROS = 'terceros';
const TIPOS_CODIGOS_BARRAS = 'tipos_codigos_barras';
const TIPOS_CONTRATOS = 'tipos_contratos';
const TIPOS_PRODUCTOS = 'tipos_productos';
const VEHICULOS = 'vehiculos';
const COTIZACIONES = 'cotizaciones';
const CUENTAS = 'cuentas';

export default {
  DOCUMENTOS_COMPRAS,
  DOCUMENTOS_VENTAS,
  CONSECUTIVOS,
  CONSTANTES,
  ATRIBUTOS,
  CLASIFICACIONESTRIBUTARIAS_ITEMS_CONCEPTOS,
  CLASIFICACIONESTRIBUTARIAS_TERCEROS_CONCEPTOS,
  CONCEPTOS_TRIBUTARIOS,
  DOCUMENTOS_INVENTARIOS,
  DOCUMENTOS_PROCESOS,
  DOCUMENTOS_WMS,
  GRUPOS_PAGOS,
  PERIODICIDADES,
  PRODUCTOS,
  TRAMITES,
  TERCEROS,
  TIPOS_CODIGOS_BARRAS,
  TIPOS_CONTRATOS,
  TIPOS_PRODUCTOS,
  VEHICULOS,
  COTIZACIONES,
  CUENTAS,
};
